const list = {
  常见问题: {
    title: "常见问题",
    content: [
      {
        title: "同城拼课是什么？",
        content:
          "和同城市、同小区小伙伴在家拼课、享受 AnyTeach 教师上门的英语课程。选择合适自己的课时包、定制上课时间地点，任何人都可以发起 1 至 8 人拼课，更可以享受发起人特权：邀请首单好友立减学费 10%。",
      },
      {
        title: "师资力量",
        content:
          "AnyTeach 教学团队的全职签约外教老师均来自于欧美国家，不仅具备多年教学经验，同时也具备国际认可资质，如 TEFL、TESL、TESOL 教学证书等。我们不仅根据教师的学历和证书严格筛选，同时注重其授课能力及综合素养。所有外教须经过严格的笔试、面试、试教、培训等层层筛选方可任教。",
      },
      {
        title: "授课教材",
        content:
          "针对不同年龄段和英语水平，AnyTeach 约课平台选用全球最大教育集团培生教育集团出版的系列教材《SuperTots》、《Longman Welcome to English》，以及外研社与剑桥大学出版社出版的《Interchange》剑桥国际英语教程。",
      },
      {
        title: "支付流程",
        content:
          "参与人先支付、发起人最后支付。<br>1. 小伙伴加入课程、立即支付。<br> 2. 发起人最后支付课程，关闭课程名额。<br>如果是 1 人上课，发起课程后随机支付即可。",
      },
      {
        title: "我可以拼课吗？",
        content:
          "不论是 1 人或是 8 人拼班，只要您或好友可以提供上课场所，AnyTeach 教学团队都可以为您指定合适的教师上门授课。<br><br>准备好上课场所，前往 <a class='link' href='//wx.anyteach.cn/#/homeclass/post'>这里</a> 发起拼课。",
      },
      {
        title: "课程可以取消吗？",
        content: "发起人可以在课程开始前 24 小时取消课程，平台将自动为已加入的所有参与人退款。",
      },
      {
        title: "可以更改上课时间吗？",
        content: "每 3 个月，发起人可以联系 AnyTeach 小管家更改一次上课时间。",
      },
      {
        title: "拼课人数怎么设定？",
        content: "您可以根据需求选择 1 至 2 人或 3 至 8 人拼课。",
      },
      {
        title: "如果拼不成怎么办？",
        content:
          "1 至 2 人拼课最少需要 1 人、3 至 8 人拼课最少需要 3 人开课（包含发起人），开课时间 24 小时前如果发起人还未支付，课程将自动失效、退款。",
      },
    ],
  },
  拼课价格: {
    title: "拼课价格",
    content: [
      {
        content: "<img src='//wx.anyteach.cn/static/images/homeclass-price.png'/>",
      },
    ],
  },
  支付须知: {
    title: "支付须知",
    content: [
      {
        title: "加入课程",
        content: "如果还有名额，开课时间 24 小时前任何人都可以加入课程并支付。",
      },
      {
        title: "课程失效",
        content: "如果发起人未在开课时间 24 小时前完成支付，课程将自动失效、退款。",
      },
    ],
  },
  邀请首单好友: {
    title: "邀请首单好友",
    content: [
      {
        content:
          "“首单好友”指的是第一次在 AnyTeach 约课平台上支付课程的用户。邀请首单好友加入课程，不论您是发起人或参与人，可以立即获得奖励。",
      },
      {
        title: "发起人",
        content: "邀请首单好友，发起人学费立减 10%。",
      },
      {
        title: "参与人",
        content: "邀请首单好友，立即获得一张 100 元同城拼课学习券。",
      },
    ],
  },
  教师搭配: {
    title: "教师搭配",
    content: [
      {
        title: "全外教课",
        content: "每节课都由 AnyTeach 的外教老师授课，提供沉浸式外教英语环境。",
      },
      {
        title: "中教 + 外教",
        content: "一节外教课，一节中教课。中西结合，双管齐下，加强听说读写。",
      },
    ],
  },
}
function getFaq(title) {
  return list[title]
}
function getKeys() {
  return Object.keys(list)
}
function dump() {
  return list
}

const faq = {
  getFaq: getFaq,
  getKeys: getKeys,
  dump: dump,
}

export default faq
